import { render, staticRenderFns } from "./TicketsBoxesView.vue?vue&type=template&id=73f73154&scoped=true"
import script from "./TicketsBoxesView.vue?vue&type=script&lang=js"
export * from "./TicketsBoxesView.vue?vue&type=script&lang=js"
import style0 from "./TicketsBoxesView.vue?vue&type=style&index=0&id=73f73154&prod&lang=scss&scoped=true"
import style1 from "./TicketsBoxesView.vue?vue&type=style&index=1&id=73f73154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f73154",
  null
  
)

export default component.exports